var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1030_3870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66016 1.16504V3.49524",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32031 1.16504V3.49524",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0688 2.33008H2.91315C2.26968 2.33008 1.74805 2.85171 1.74805 3.49518V11.6509C1.74805 12.2943 2.26968 12.816 2.91315 12.816H11.0688C11.7123 12.816 12.2339 12.2943 12.2339 11.6509V3.49518C12.2339 2.85171 11.7123 2.33008 11.0688 2.33008Z",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74805 5.82568H12.2339",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66016 8.15576H4.66598",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99023 8.15576H6.99606",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32031 8.15576H9.32614",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66016 10.4858H4.66598",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99023 10.4858H6.99606",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32031 10.4858H9.32614",
    stroke: "#99A1AF",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1030_3870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9812,
    height: 13.9812,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar1);
export default __webpack_public_path__ + "static/media/calendar1.9e28293a9f18ece575df7ada9536a4c3.svg";
export { ForwardRef as ReactComponent };